// Frontend-visible mapping from phase key to the display name shown in the
// Current Phase card and Start/Resume buttons. Every phase with a backend
// agent in agentRegistry.ts should have an entry here — missing entries
// cause the "Agent: …" line and the primary CTA to silently disappear,
// leaving users with no session entry point (see fix/project-dashboard-
// start-session-button).
//
// The backend's phase → agent mapping lives in apps/api/src/services/
// agentRegistry.ts; if that mapping changes, update this file in lockstep.

import type { PhaseKey } from '../components/PhaseBadge';

export const PHASE_AGENTS: Partial<Record<PhaseKey, string>> = {
  phase_1_requirements:    'PM Requirements Agent',
  phase_2_architecture:    'Architecture Agent',
  phase_2_5_ux_design:     'UX Design Agent',
  phase_3_sprint_planning: 'Sprint Planning Agent',
  phase_4_development:     'Development Agent',
  phase_5_code_review:     'Code Review Agent',
  phase_6_testing:         'QA Agent',
  phase_7_deployment:      'Deployment Agent',
};
